<template>
  <div class="d-flex align-items-center mb-1 top-items text-secondary text-medium">
    <span class="text-truncate top-item team-name" :title="team">{{ team }}</span>
    <span class="text-truncate top-item team-timeline" :title="timeline">{{ timeline }}</span>
    <span class="text-truncate top-item" v-if="owner" :title="owner.displayName">{{
      owner.displayName
    }}</span>
  </div>
</template>

<script>
import { intervalWithId } from '@/interval'

/**
 * This shows goal team name, timeline and owner
 */
export default {
  name: 'GoalMeta',
  props: ['goal'],
  components: {},
  data() {
    return {}
  },
  computed: {
    owner() {
      const primaryOwner = this.goal.ownerships.find(owner => owner.isPrimary)
      return primaryOwner && this.$store.getters.userById(primaryOwner.userId)
    },
    timeline() {
      return intervalWithId(this.goal.timeline).name
    },
    team() {
      return this.$store.getters.teamById(this.goal.teamId).name
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.top-items .top-item:not(:first-child):before {
  content: '';
  display: inline-block;
  height: 4px;
  width: 4px;
  background-color: $tertiary;
  border-radius: 50%;
  margin-right: 4px;
  margin-left: 4px;
  vertical-align: middle;
}
</style>
